import * as $ from 'jquery';

export function setupRegistration() {
    const $referopen = $('#referopen');

    $referopen.on("click", function () {
        $('#referfields').show('slow');
        $('#referopenarea').hide();
    });

    $('.cvnshow').on("click", function () {
        window.open("/Enroll/CVNPopup", "cvn", "menubar=0,resizable=0,width=650,height=550");
    });
}
